import Vue from 'vue';
import scm from "../scm"

const Scm = {};

// eslint-disable-next-line no-unused-vars
Scm.install = function (Vue, option) {
    Vue.scm = scm;
    Window.scm = scm;
    Object.defineProperties(Vue.prototype, {
        scm: {
            get() {
                return scm;
            }
        },
        // 所以在vue文件中就可以用this.$scm.xxx来调用
        $scm: {
            get() {
                return scm;
            }
        }
    })
};

Vue.use(Scm);

export default Scm

